<template>
    <div class="flex-1 flex">
        <!-- LEFT -->
        <div class="flex-col w-7/12 ">
            <!-- #################### Materials -->
            <div class="text-xs font-semibold text-gray-600 mb-0.5">Materials</div>
            <div class="flex-1 flex flex-col">
                <div class="flex flex-1 text-xs text-gray-500 mb-0.5">
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pl-2">Material name</div>
                    <div class="w-16 flex -ml-px pl-2">Qty</div>
                    <div class="w-16 flex -ml-px pl-2">UoM</div>
                    <div class="w-20 flex -ml-px pr-2">
                        <div class="w-full text-right">Value</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
                <template v-if="materialItems.length">
                    <div class="flex flex-1 -my-px" v-for="(material,index) in materialItems">
                        <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0">
                            <cost-plan-component :item="material" :readonly="readonly"
                                                 @componentUpdated="recalc(); update()"
                                                 :components="componentItems"></cost-plan-component>
                        </div>
                        <div class="flex flex-1 truncate">
                            <page-cell
                                v-if="!readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :class="getBGClass()"
                                :ref="'material'+index"
                                placeholder="Material..."
                                v-model="material.name"
                                @change="update()"
                            ></page-cell>
                            <textarea v-else
                                      class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
                                      style="cursor:auto !important"
                                      rows="1"
                                      disabled
                                      :value="material.name"
                            ></textarea>
                        </div>
                        <div class="w-16 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :class="getBGClass()"
                                placeholder="Qty..."
                                v-model="material.quantity"
                                @input="recalc()"
                                @change="material.quantity = resolveNumericText(material.quantity); update()"
                            ></page-cell>
                        </div>
                        <div class="w-16 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :class="getBGClass()"
                                placeholder="UoM..."
                                v-model="material.uom"
                                @change="update()"
                                @input="recalc()"
                            ></page-cell>
                        </div>
                        <div class="w-20 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                :currency="true"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 text-right"
                                :class="getBGClass()"
                                placeholder="Value..."
                                @change="valueAsCurrency($event,material); update()"
                                v-model="material.value"
                                @input="recalc()"
                            ></page-cell>
                        </div>
                        <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5">
                            <ui-dropdown menu-class="p-3 w-72" v-if="!readonly">
                                <template #default="{ toggle }">
                                    <button @click="toggle"
                                            class="w-3 h-3 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="fas fa-trash" danger @click="removeMaterial(index);close()">
                                        Delete
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                    </div>
                </template>
                <div class="flex flex-1 text-xs text-gray-400 -my-px" v-else>
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pr-2 bg-white border border-gray-200">
                        <div class="w-full text-center py-1 italic">No Materials</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
                <div class="flex flex-1">
                    <div class="relative w-4 flex-shrink-0 ml-2 self-start pt-1 pb-0 text-xs text-gray-400"
                         v-if="!readonly">
                        <i class="fas fa-plus"></i>
                    </div>
                    <page-cell
                        v-if="!readonly"
                        :read-only="readonly"
                        class="text-xs -ml-px -my-px px-1 pt-1 pb-0 border-none flex-1 bg-transparent text-gray-400 focus:outline-none focus:ring-0"
                        placeholder="Add new material..."
                        @input="addMaterial"
                        :key="'m'+newKey"
                        v-model="newMaterial"
                    ></page-cell>
                    <div class="flex flex-1 text-xs text-gray-500 mt-0.5" v-if="materialItems.length">
                        <div class="flex flex-1 truncate pr-2">
                            <div class="w-full text-right">Material Total</div>
                        </div>
                        <div class="w-20 flex -ml-px pr-1">
                            <div class="w-full text-right pr-px" v-text="materialTotal"></div>
                        </div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
            </div>
            <!-- #################### Labour -->
            <div class="text-xs font-semibold text-gray-600 mt-2 mb-0.5">Labour</div>
            <div class="flex-1 flex flex-col">
                <div class="flex flex-1 text-xs text-gray-500 mb-0.5">
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pl-2">Labour rate</div>
                    <div class="w-20 flex -ml-px pr-2" v-if="itemQuantity">
                        <div class="w-full text-right">Rate</div>
                    </div>
                    <div class="w-20 flex -ml-px pr-2">
                        <div class="w-full text-right">Value</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
                <template v-if="labourItems.length">
                    <div class="flex flex-1 -my-px" v-for="(labour,index) in labourItems">
                        <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0">
                            <cost-plan-component :item="labour" :readonly="readonly"
                                                 @componentUpdated="recalc(); update()"
                                                 :components="componentItems"></cost-plan-component>
                        </div>
                        <div class="flex flex-1 truncate">
                            <page-cell
                                v-if="!readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :ref="'labour'+index"
                                :class="getBGClass()"
                                placeholder="Labour..."
                                @change="update()"
                                v-model="labour.name"
                            ></page-cell>
                            <textarea v-else
                                      class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
                                      style="cursor:auto !important"
                                      rows="1"
                                      disabled
                                      :value="labour.name"
                            ></textarea>
                        </div>
                        <div class="w-20 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 text-right"
                                :class="getBGClass()"
                                placeholder="Rate..."
                                :currency="true"
                                @change="rateAsCurrency($event,labour); update()"
                                v-model="labour.rate"
                                @input="recalcRate()"
                            ></page-cell>
                        </div>
                        <div class="w-20 flex -ml-px" v-if="itemQuantity">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 text-right"
                                :class="getBGClass()"
                                placeholder="Value..."
                                :currency="true"
                                @change="valueAsCurrency($event,labour); update()"
                                v-model="labour.value"
                                @input="recalc()"
                            ></page-cell>
                        </div>
                        <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5">
                            <ui-dropdown menu-class="p-3 w-72" v-if="!readonly">
                                <template #default="{ toggle }">
                                    <button @click="toggle"
                                            class="w-3 h-3 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="fas fa-trash" danger @click="removeLabour(index);close()">
                                        Delete
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                    </div>
                </template>
                <div class="flex flex-1 text-xs text-gray-400 -my-px" v-else>
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pr-2 bg-white border border-gray-200">
                        <div class="w-full text-center py-1 italic">No Labour Rates</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5" v-if="!readonly"></div>
                </div>
                <div class="flex flex-1">
                    <div class="relative w-4 flex-shrink-0 ml-2 self-start pt-1 pb-0 text-xs text-gray-400"
                         v-if="!readonly">
                        <i class="fas fa-plus"></i>
                    </div>
                    <page-cell
                        v-if="!readonly"
                        :read-only="readonly"
                        class="text-xs -ml-px -my-px px-1 pt-1 pb-0 border-none flex-1 bg-transparent text-gray-400 focus:outline-none focus:ring-0"
                        placeholder="Add new labour..."
                        v-model="newLabour"
                        :key="'l'+newKey"
                        @input="addLabour"
                    ></page-cell>
                    <div class="flex flex-1 text-xs text-gray-500 mt-0.5" v-if="labourItems.length">
                        <div class="flex flex-1 truncate pr-2">
                            <div class="w-full text-right">Labour Total</div>
                        </div>
                        <div class="w-20 flex -ml-px pr-1">
                            <div class="w-full text-right pr-px" v-text="labourRateTotal"></div>
                        </div>
                        <div class="w-20 flex -ml-px pr-1">
                            <div class="w-full text-right pr-px" v-text="labourTotal"></div>
                        </div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
            </div>
            <!-- #################### Fixed Costs -->
            <div class="text-xs font-semibold text-gray-600 mt-2 mb-0.5">Fixed Costs</div>
            <div class="flex-1 flex flex-col">
                <div class="flex flex-1 text-xs text-gray-500 mb-0.5">
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pl-2">Fixed cost description</div>
                    <div class="w-16 flex -ml-px pl-2">Qty</div>
                    <div class="w-20 flex -ml-px pr-2">
                        <div class="w-full text-right">Value</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
                <template v-if="fixedCostItems.length">
                    <div class="flex flex-1 -my-px" v-for="(fixedCost,index) in fixedCostItems">
                        <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0">
                            <cost-plan-component :item="fixedCost" :readonly="readonly"
                                                 @componentUpdated="recalc(); update()"
                                                 :components="componentItems"></cost-plan-component>
                        </div>
                        <div class="flex flex-1 truncate">
                            <page-cell
                                v-if="!readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :ref="'fixedCost'+index"
                                :class="getBGClass()"
                                placeholder="Fixed Cost..."
                                @change="update()"
                                v-model="fixedCost.name"
                            ></page-cell>
                            <textarea v-else
                                      class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
                                      style="cursor:auto !important"
                                      rows="1"
                                      disabled
                                      :value="fixedCost.name"
                            ></textarea>
                        </div>
                        <div class="w-16 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200"
                                :class="getBGClass()"
                                placeholder="Qty..."
                                v-model="fixedCost.quantity"
                                @change="update()"
                                @input="recalc()"
                            ></page-cell>
                        </div>
                        <div class="w-20 flex -ml-px">
                            <page-cell
                                :read-only="readonly"
                                class="text-xs text-gray-600 m-0 px-1 py-1 border border-gray-200 text-right"
                                :class="getBGClass()"
                                placeholder="Value..."
                                v-model="fixedCost.value"
                                :currency="true"
                                @change="valueAsCurrency($event,fixedCost); update()"
                                @input="recalc()"
                            ></page-cell>
                        </div>
                        <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5">
                            <ui-dropdown menu-class="p-3 w-72" v-if="!readonly">
                                <template #default="{ toggle }">
                                    <button @click="toggle"
                                            class="w-3 h-3 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="fas fa-trash" danger
                                                      @click="removeFixedCost(index);close()">
                                        Delete
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                    </div>
                </template>
                <div class="flex flex-1 text-xs text-gray-400 -my-px" v-else>
                    <div class="relative w-6 flex-shrink-0 ml-0 self-start py-0"></div>
                    <div class="flex flex-1 truncate pr-2 bg-white border border-gray-200">
                        <div class="w-full text-center py-1 italic">No Fixed Costs</div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5" v-if="!readonly"></div>
                </div>
                <div class="flex flex-1">
                    <div class="relative w-4 flex-shrink-0 ml-2 self-start pt-1 pb-0 text-xs text-gray-400"
                         v-if="!readonly">
                        <i class="fas fa-plus"></i>
                    </div>
                    <page-cell
                        v-if="!readonly"
                        :read-only="readonly"
                        class="text-xs -ml-px -my-px px-1 pt-1 pb-0 border-none flex-1 bg-transparent text-gray-400 focus:outline-none focus:ring-0"
                        placeholder="Add new fixed cost..."
                        v-model="newFixedCost"
                        :key="'f'+newKey"
                        @input="addFixedCost"
                    ></page-cell>
                    <div class="flex flex-1 text-xs text-gray-500 mt-0.5" v-if="fixedCostItems.length">
                        <div class="flex flex-1 truncate pr-2">
                            <div class="w-full text-right">Fixed Costs Total</div>
                        </div>
                        <div class="w-20 flex -ml-px pr-1">
                            <div class="w-full text-right pr-px" v-text="fixedCostTotal"></div>
                        </div>
                    </div>
                    <div class="w-4 flex-shrink-0 ml-2 self-start py-1.5"></div>
                </div>
            </div>
        </div>
        <!-- RIGHT -->
        <div class="w-5/12 ml-2">
            <!-- #################### Build up Components -->
            <div class="flex-1 text-xs font-semibold text-gray-600 mb-2">Build-up Components</div>
            <div class="flex-1 relative mb-" v-for="(component,index) in componentItems">
                <div class="flex">
                    <div class="w-8 ml-0 mt-1.5 text-gray-500 text-sm">
                        <div class="cursor-pointer relative w-[22px] h-[22px] mt-0">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22px"
                                height="22px"
                                viewBox="0 0 36 36"
                                fill="#FFFFFF"
                                stroke="rgb(59 130 246)"
                                stroke-width="1"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="absolute"
                                style="left: 0px; top: 0px"
                            >
                                <circle cx="18" cy="18" r="17"/>
                            </svg>
                            <div class="flex justify-center text-blue-500 relative mt-px">
                                <div class="mt-0.5 font-bold leading-4 pt-px" style="font-size: 0.6em"
                                     v-text="component.name.substring(0,3)" :key="renderKey"></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-1">
                        <cost-plan-existing-component-search :costPlan="costPlan"
                                                             #default="{ close, open, query, setQuery }"
                                                             @selected:knownComponent="(c) => component.name=c"
                                                             class="w-full"
                                                             v-if="!readonly"
                        >
                            <page-cell
                                class="w-full text-base text-blue-600 -my-px px-2 py-1.5 border border-gray-200"
                                :class="getBGClass()"
                                :ref="'component'+index"
                                placeholder="Buildup Component..."
                                @change="update()"
                                @input="setQuery(component.name)"
                                @focus="setQuery(component.name);open()"
                                v-model="component.name"
                            ></page-cell>
                        </cost-plan-existing-component-search>
                        <textarea v-else
                                  class="text-base text-blue-600 -my-px px-2 py-1.5 border border-gray-200 resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative hover:border hover:border-gray-200 cursor-text"
                                  style="cursor:auto !important"
                                  rows="1"
                                  disabled
                                  :value="component.name"
                        ></textarea>
                    </div>
                    <div
                        class="w-20 text-base text-blue-600 -ml-px -my-px px-2 py-1.5 border border-gray-200  text-sm bg-white"
                        v-text="component.percent"
                    ></div>
                    <div class="w-6 flex-shrink-0 ml-2 self-start py-1.5" v-if="!readonly">
                        <ui-dropdown menu-class="p-3 w-72">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-3 h-3 mt-1.5 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-trash" danger
                                                  @click="removeComponent(component);close()">
                                    Delete
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
                <div class="px-2 pb-3">
                    <div class="w-full relative pr-4 h-4 top-2 text-xs">
                        <div class="h-1 border border-gray-200 rounded bg-white absolute top-1.5 w-full"></div>
                        <div class="h-1 border border-gray-200 rounded bg-blue-400 absolute top-1.5 w-full"
                             :style="'width:'+component.percent"></div>
                        <div class="w-full absolute top-0" style="padding-left:0rem; padding-right:2rem;">
                            <div
                                class="top-0 h-4 bg-white w-8 border border-gray-300 bg-white rounded align-text-top text-gray-400 text-xs m-0 py-0 px-1 h-4"
                                :style="'line-height:0.95rem; margin-left:'+component.percent"
                                v-text="math.floor(parseFloat(component.percent))+'%'"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-1" v-if="!readonly">
                <div class="w-6 ml-1 mt-2.5 text-gray-400 text-sm">
                    <i class="fas fa-plus"></i>
                </div>
                <page-cell
                    class="text-base text-gray-400 border-none bg-transparent border-none -ml-px -my-px px-2 py-1.5 focus:outline-none focus:ring-0"
                    placeholder="Add a new component..."
                    v-model="newComponentName"
                    @input="addComponent"
                >
                </page-cell>
            </div>
        </div>
    </div>
</template>

<script>
import PageCell from "../../../ui/PageCell.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";
import CostPlanComponent from "./CostPlanComponent.vue";
import {resolveNumericText, toCurrency, uuid} from "@utils"
import * as math from "mathjs";
import EstimateExistingUsersSearch from "../../../estimation/estimates/send/EstimateExistingUsersSearch.vue";
import UiInput from "../../../ui/UiInput.vue";
import CostPlanExistingComponentSearch from "./CostPlanExistingComponentSearch.vue";

export default {
    components: {
        CostPlanExistingComponentSearch,
        UiInput, EstimateExistingUsersSearch, CostPlanComponent, UiDropdownDivider, UiDropdown, PageCell
    },
    props: {
        costPlan: Object,
        item: Object,
        showOmitted: Boolean,
        readonly: false,
    },
    data() {
        let c = this.item.buildup;
        return {
            componentItems: c ? c.components : [],
            materialItems: c ? c.materials : [],
            labourItems: c ? c.labour : [],
            fixedCostItems: c ? c.fixedCosts : [],
            newComponentName: '',
            newMaterial: '',
            newLabour: '',
            newFixedCost: '',
            renderKey: 0,
            math,
            newKey: 0,
            resolveNumericText
        }
    },
    computed: {
        materialTotal() {
            return toCurrency(this.materialItems.reduce((a, i) =>
                    math.round(a + math.round(resolveNumericText(i.value), 2), 2)
                , 0))
        },
        labourTotal() {
            return toCurrency(this.labourItems.reduce((a, i) =>
                    math.round(a + math.round(resolveNumericText(i.value), 2), 2)
                , 0))
        },
        labourRateTotal() {
            return toCurrency(math.round(this.labourItems.reduce((a, i) =>
                    math.round(a + math.round(resolveNumericText(i.value), 2), 2)
                , 0) / (this.itemQuantity ? this.itemQuantity : 1), 2))
        },
        fixedCostTotal() {
            return toCurrency(this.fixedCostItems.reduce((a, i) =>
                    math.round(a + math.round(resolveNumericText(i.value), 2), 2)
                , 0))
        },
        itemQuantity() {
            return resolveNumericText(parseFloat(this.item.quantity.trim()));
        }
    },
    methods: {
        update(snapshot = true) {
            this.recalc();
            this.item.buildup = {
                components: this.componentItems,
                fixedCosts: this.fixedCostItems,
                labour: this.labourItems,
                materials: this.materialItems,
            };
            this.$emit('changed', snapshot);
        },
        valueAsCurrency(value, target) {
            target.value = toCurrency(resolveNumericText(value), 'GBP', 2);
        },
        rateAsCurrency(value, target) {
            target.rate = toCurrency(resolveNumericText(value), 'GBP', 2);
        },
        addMaterial() {
            this.materialItems.push({name: this.newMaterial, uom: '', quantity: '0', value: '£0.00'})
            this.newMaterial = '';
            this.newKey++;
            this.$nextTick(() => {
                this.$refs['material' + (this.materialItems.length - 1)][0].focusAsNew()
            })
            this.update(false);
        },
        removeMaterial(index) {
            this.materialItems.splice(index, 1);
            this.update();
        },
        addLabour() {
            this.labourItems.push({name: this.newLabour, rate: '£0.00', value: '£0.00'})
            this.newLabour = '';
            this.newKey++;
            this.$nextTick(() => {
                this.$refs['labour' + (this.labourItems.length - 1)][0].focusAsNew()
            })
            this.update(false);
        },
        removeLabour(index) {
            this.labourItems.splice(index, 1);
            this.update(false);
        },
        addFixedCost() {
            this.fixedCostItems.push({name: this.newFixedCost, quantity: '0', value: '£0.00'})
            this.newFixedCost = '';
            this.newKey++;
            this.$nextTick(() => {
                this.$refs['fixedCost' + (this.fixedCostItems.length - 1)][0].focusAsNew()
            })
            this.update(false);
        },
        removeFixedCost(index) {
            this.fixedCostItems.splice(index, 1);
            this.update();
        },
        addComponent() {
            let component = {name: this.newComponentName, percent: '0%', id: uuid()}
            this.componentItems.push(component)
            this.newComponentName = '';
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs['component' + (this.componentItems.length - 1)][0].focusAsNew()
                })
            })
            this.update(false);
        },
        removeComponent(component) {
            this.fixedCostItems.concat(this.materialItems, this.labourItems).filter((i) => i.componentId === component.id).forEach((i) => {
                i.componentId = ''
                delete i.component
            })
            this.componentItems = this.componentItems.filter((i) => i.id !== component.id)
            this.update();
        },
        getBGClass() {
            return ' bg-white';
        },
        clamp(value) {
            return Math.round(Math.min(100, Math.max(0, Math.abs(parseFloat(value)))) || 0)
        },
        recalcRate() {
            this.labourItems.forEach((i) => {
                i.value = toCurrency(math.round(resolveNumericText(i.rate) * (this.itemQuantity ? this.itemQuantity : 1), 2), 'GBP', 2);
            })
            this.recalc()
        },
        recalc() {
            let total = 0;
            this.labourItems.forEach((i) => {
                i.rate = math.round(resolveNumericText(i.value) / (this.itemQuantity ? this.itemQuantity : 1), 2);
            })
            this.componentItems.forEach((i) => {
                i.value = 0;
            })
            this.materialItems.concat(this.fixedCostItems, this.labourItems).forEach((i) => {
                let value = math.round(resolveNumericText(i.value), 2);
                let component = this.componentItems.find(c => c.id === i.componentId)
                if (component) {
                    component.value = math.round(resolveNumericText(component.value) + value, 2);
                }
                total = math.round(total + value, 2)
            })
            this.componentItems.forEach((i) => {
                i.ratio = total ? (math.round(resolveNumericText(i.value), 2) / total) : 0;
                i.percent = math.floor(i.ratio * 100, 2) + '%'
            })
            this.renderKey++
        }
    },
    mounted() {
        this.recalc()
    },
    beforeMount() {
        this.recalc()
    }
}
</script>
